import React from 'react';
import { Typography } from '@one-thd/sui-atomic-components';

interface IQRCode {
  sorisId: string;
  imageSrc: string;
}

const QRCode = ({ sorisId, imageSrc }: IQRCode) => {
  return (
    <div className="qr-code-size">
      <img src={imageSrc} height={233} width={233} alt="QR Code" />
      <div className="sui-flex sui-justify-center sui-mt-4">
        <Typography variant="body-xs">Return ID: {sorisId}</Typography>
      </div>
    </div>
  );
};

export default QRCode;
